export default "__VITE_ASSET__CA3a7nyx__"